<template>
    <el-dialog :visible="visible" @close="handleClose" custom-class="product-added-popup module-popup" top="2vh">
        <h1 class="product-title" v-if="title">{{ title }}</h1>
        <div class="product__image">
            <a :href="url">
                <img :src="image" :alt="imageAlt" class="image-full-width"/>
            </a>
        </div>
        <span slot="footer" class="dialog-footer">
                <a href="javascript:;" @click.prevent="handleClose">Close</a>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: 'PopupModule',
        props: {
            popupName: {
                type: String,
                required: true,
            },
            config: {
                type: Object,
                required: true
            },
            image: {
                type: String,
                required: false,
                default: null
            }
        },
        data: () => ({
            visible: false,
            alreadyShow: false,

            mouse: {
                x: 0,
                y: 0
            }
        }),
        computed: {
            imageAlt() {
                return this.config.image_alt || null;
            },
            url() {
                return this.config.url;
            },
            title() {
                return this.config.title || null
            },
        },
        mounted() {
            this.setAlreadyShow();
            switch (this.config.visible_logic) {
                case 'on_leave':
                    this.handleOnLeavePopup();
                    break;
                case 'once':
                default:
                    this.handleOncePopup();
                    break
            }
        },
        methods: {
            handleClose() {
                this.visible = false;
                this.alreadyShow = true;
            },
            handleOnLeavePopup() {
                document.addEventListener('mousemove', (e) => {
                    this.mouse.x = e.clientX;
                    this.mouse.y = e.clientY;
                });

                document.addEventListener('mouseleave', (e) => {
                    if (this.mouse.y < 100) {
                        this.handleOncePopup();
                    }
                })
            },
            handleOncePopup() {
                if (!this.alreadyShow) {
                    this.visible = true;

                    this.$cookies.set(this.popupName, 1, '30MIN')
                }
            },
            setAlreadyShow() {
                this.alreadyShow = !!this.$cookies.get(this.popupName);
            },
            clearCookie() {
                this.$cookies.remove(this.popupName);
            }
        }
    }
</script>
